/**
 * Smart Alert Handler
 * Handles the OnMessageSend event for Classic and Modern Outlook.
 */
class SmartAlertManager {
  constructor() {
    // Bind methods to ensure 'this' context remains correct
    this.onMessageSendHandler = this.onMessageSendHandler.bind(this);
    this.GetItem = this.GetItem.bind(this);
    this.GetLocalStorageItem = this.GetLocalStorageItem.bind(this);
  }

  GetItem(key) {
    var value = Office.context.roamingSettings.get(key);
    if (!value) {
      value = false;
    }
    return value;
  }

  GetLocalStorageItem(key) {
    var value = window.localStorage.getItem(key);
    if (!value) {
      value = false;
    }
    return value;
  }

  onMessageSendHandler(event) {
    var isAddinOpen;
    var forceEmailFiling;
    var isSendAndFileProjectSelected;
    var shouldShowSmartAlert;
    var language;
    var hideAlert;

    try {
      // Platform detection for storage strategy
      if (Office.context && (Office.context.platform === Office.PlatformType.PC || Office.context.platform == null)) {
        // Classic Outlook Desktop - use roaming settings
        forceEmailFiling = JSON.parse(this.GetItem('showForceEmailFiling'));
        shouldShowSmartAlert = forceEmailFiling;
        language = this.GetItem("language");
        hideAlert = JSON.parse(this.GetItem("hideAlert"));
      } else {
        // New Outlook desktop/web/mac - use localStorage
        isAddinOpen = Date.now() - (Number(JSON.parse(this.GetLocalStorageItem('addInLastOpen'))) || 0) < 1000;
        forceEmailFiling = JSON.parse(this.GetLocalStorageItem('showForceEmailFiling'));
        isSendAndFileProjectSelected = JSON.parse(this.GetLocalStorageItem('isSendAndFileProjectSelected')) && isAddinOpen;
        shouldShowSmartAlert = forceEmailFiling && !isSendAndFileProjectSelected;
        language = this.GetLocalStorageItem("language");
        hideAlert = JSON.parse(this.GetLocalStorageItem("hideAlert"));
      }
    } catch (error) {
      console.log("Error getting values from storage in launchevent", error);
    }

    // Localization Helpers defined inside the method scope
    function getMarkdown() {
      if (language === "de") return "Sie senden gleich eine E-Mail, ohne diese in einem Projekt abzulegen. \n " + "**Ein Projekt im Add-in auswählen oder einfach senden.**";
      return "You're about to send an email without filing it to a project. \n " + "**Select a project in the Add-in or send anyway.**";
    }

    function getDefaultText() {
      if (language === "de") return "Sie senden gleich eine E-Mail, ohne diese in einem Projekt abzulegen. \n " + "Ein Projekt im Add-in auswählen oder einfach senden.";
      return "You're about to send an email without filing it to a project. \n " + "Select a project in the Add-in or send anyway.";
    }

    function getCancelLabel() {
      if (language === "de") return "Add-In verwenden";
      return "Use the Add-in";
    }

    // Execution Logic
    if (shouldShowSmartAlert && !hideAlert) {
      try {
        event.completed({
          allowEvent: false,
          errorMessage: getDefaultText(),
          errorMessageMarkdown: getMarkdown(),
          commandId: "sendAndFileButton",
          cancelLabel: getCancelLabel(),
          sendModeOverride: Office.MailboxEnums.SendModeOverride.PromptUser
        });
      } catch (e) {
        console.error("smart alert error:", e);
        event.completed({ allowEvent: true });
      }
    } else {
      event.completed({ allowEvent: true });
    }
  }
}

// --- INITIALIZATION ---

// 1. Instantiate the class
const smartAlertManager = new SmartAlertManager();

// 2. IMMEDIATE ASSOCIATION (Fix for Classic Outlook Hang)
// We associate the method directly at the top level so the host finds it instantly.
Office.actions.associate("onMessageSendHandler", smartAlertManager.onMessageSendHandler);

// 3. Optional onReady for other initialization tasks
Office.onReady(function (info) {
  if (info.host === Office.HostType.Mailbox) {
    // Other setup if needed
  }
});